import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

dayjs.updateLocale('en', {
    relativeTime: {    
        future: "in %s",
        past: "%s",
        s: '1s',
        ss: "%ds",
        m: "1m",
        mm: "%dm",
        h: "1h",
        hh: "%dh",
        d: "1d",
        dd: function (number: number) {
          if (number >= 11) {
            return `${Math.round(number / 7)}w`
          }
          return `${number}d`;
        },
        M: "4w",
        MM: "%dmo",
        y: "1y",
        yy: "%dy"
    }
});

export const formatDate = (date: string | number | Date | dayjs.Dayjs) => {
    return dayjs(date).format('LLL z');
};

export const formatDateWithoutTimezone = (date: string | number | Date | dayjs.Dayjs) => {
    return dayjs(date).format('LLL');
};

export const formatRelativeTime = (date: string | number | Date | dayjs.Dayjs) => {
    return dayjs(date).fromNow();
};

/**
 * Format a timestamp for notification-style lists: return a concise relative
 * label (e.g. "3h", "2d") when the value is within the last 7 days, and a
 * short month+day label (e.g. "Mar 17", "Feb 3") when it is older. Falls back
 * to an empty string if the value cannot be parsed.
 */
export const formatNotificationTimestamp = (
    date: string | number | Date | dayjs.Dayjs
): string => {
    const parsed = dayjs(date);
    if (!parsed.isValid()) {
        return "";
    }

    const sevenDaysAgo = dayjs().subtract(7, "day");
    if (parsed.isAfter(sevenDaysAgo)) {
        return parsed.fromNow();
    }

    return parsed.format("MMM D");
};

export default dayjs;